export default {
  notFoundTitle: 'Room 404 is not one of ours',
  notFoundLead: 'We could not find this page. It may have changed doors during the relaunch – or there is a typo in the address.',
  notFoundCta: 'Back to the homepage',
  notFoundLinksIntro: 'Perhaps you were looking for:',
  notFoundLinkRooms: 'Rooms and rates',
  notFoundLinkBooking: 'Check availability',

  legalBack: 'Back',

  // Imprint & privacy notice are German legal texts – kept in German.
};
